import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  BackwardArrow,
  coachDemoImg,
  helpIcon,
} from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { DashboardBookingDetailCard } from "../../../../stories/DashboardBookingDetailCard/DashboardBookingDetailCard.jsx";
import classes from "./EvaluatePerformance.module.css";
import { Button } from "../../../../stories/Button/Button";
import CongratsModal from "../../../Modals/CoachFlow/Dashboard/Congrats/Congrats";

export default function EvaluatePerformance({ setIsEvaluate }) {
  const [feedback, setFeedback] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittedFeedback, setSubmittedFeedback] = useState(null);
  return (
    <div className={`${[classes.evaluatePerformance].join(" ")}`}>
      <Row className="g-0">
        <Col md={7} xl={8} className={classes.left}>
          <Row className="g-0">
            <Col md={12}>
              <LinkButtonWithIcon
                text={"Go back"}
                leftIcon={BackwardArrow}
                onClick={() => setIsEvaluate(false)}
              />
              <h3
                className={classes.mainHeading}
                style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
              >
                <span>Evaluate Jessica’s</span>
                <span>performance</span>
              </h3>
            </Col>
            <Col
              md={12}
              className={classes.border}
              style={{ borderTopColor: Colors.neutralShadesOfGainsboro }}
            />
            {submittedFeedback ? (
              <Col md={12} className={classes.yoursFeedback}>
                <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                  Your's feedback of the lesson
                </h5>
                <p
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
                >
                  {submittedFeedback}
                </p>
              </Col>
            ) : (
              <>
                <Col md={12}>
                  <TextArea
                    label={"Share your feedback about the lesson"}
                    iconHoverList={[
                      "What did you work on with Jessica?",
                      "What did Jessica do well on?",
                      "What can Jessica improve on?",
                    ]}
                    icon={helpIcon}
                    state={feedback}
                    setter={setFeedback}
                    placeholder=""
                  />
                </Col>
                <Col md={12} className={classes.btnCol}>
                  <Button
                    label={"Submit"}
                    primary={true}
                    size={"Large"}
                    customStyle={{ width: "144px" }}
                    disabled={feedback?.length > 0 ? false : true}
                    onClick={() => {
                      setSubmittedFeedback(feedback);
                      setIsSubmitting(true);
                    }}
                  />
                </Col>
              </>
            )}
          </Row>
        </Col>
        <Col md={5} xl={4}>
          <DashboardBookingDetailCard
            data={{
              userData: {
                displayName: "Kate Smith",
                photo: coachDemoImg,
                rating: 5,
                sport: "Beginner",
                reviews: [{}, {}, {}, {}, {}, {}, {}],
                role: "coach",
              },
              price: 85,
              date: "Aug 12, 2021",
              startTime: "12:30PM",
              endTime: "2:30PM",
              location: "DeWitt Clinton Park, W 54th St, New York, NY",
              status: "completed",
            }}
          />
        </Col>
        <CongratsModal show={isSubmitting} setShow={setIsSubmitting} />
      </Row>
    </div>
  );
}
